export const DEFAULT_INITIAL_SECTION = 1;
export const DEFAULT_ANIMATION_DELAY = 1500;
